const customerDiv = document.querySelector("div[data-customer-id]");

if (customerDiv) {
  const customerId = customerDiv?.dataset?.customerId ?? "";
  const exactMatchDataForm = customerDiv.querySelector(
    "form[data-exact-match]"
  );
  const formResultEle = document.querySelector("div[data-exact-match-result]");
  const injectorOneEle = exactMatchDataForm.querySelector(
    "[data-injector-id-one]"
  );
  const injectorTwoEle = exactMatchDataForm.querySelector(
    "[data-injector-id-two]"
  );

  exactMatchDataForm.addEventListener("submit", (e) => {
    e.preventDefault();

    const injectorOneVal = injectorOneEle.value;
    const injectorTwoVal = injectorTwoEle.value;

    if (injectorOneVal.length > 0 && injectorTwoVal.length > 0) {
      getDashboardUrl(injectorOneVal, injectorTwoVal);
    }
  });

  const getDashboardUrl = async (injectorOne, injectorTwo) => {
    const url =
      "https://nlwi0trsxh.execute-api.ap-southeast-2.amazonaws.com/beta//group/double_injector_search";

    formResultEle.innerHTML = `<p>Loading ...</p>`;

    try {
      const response = await fetch(url, {
        method: "POST",
        body: JSON.stringify({
          injector_id_one: injectorOne,
          injector_id_two: injectorTwo,
        }),
        headers: {
          "Content-Type": "application/json",
          "X-Api-Key": "mgxFX4NnlW7cc5FF0HBnN2l4Cp00uu7617HE62ZA",
        },
      });

      if (!response.ok) {
        throw new Error(`Response status: ${response.status}`);
      }

      const data = await response.json();

      if (data.success) {
        window.location = `https://dashboard.xsinjectors.com/group/summary/${data.group}?user_id=${customerId}`;
      } else {
        formResultEle.innerHTML = `<p class="text-red">${data.message}. Please try again.</p>`;
      }
    } catch (error) {
      console.error(error.message);
    }
  };
}
